import { Component, Vue } from 'vue-property-decorator';
import WithRender from  './approved.html';
import config from "@/settings/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _axios from '@/services/axios';
import moment from 'moment';
import { UnApprovedType } from '@/types/deposit.type';

@WithRender
@Component({
  filters:{
    formateDate(value: string)
    {
      return moment(value).format('YYYY-MM-DD HH:mm A')
    }
  },
  components: {
    Loading,
  },
})
export default class Approved extends Vue {
  unApproved = {} as UnApprovedType;
  items = [];
  fields = [
    {
      key: "userName",
    },
    {
      key: "fullName",
    },
    {
      key: "reflectingInBank",
    },
    {
      key: "depositType",
    },
    {
      key: "reference",
    },
    {
      key: "comment",
    },
    {
      key: "createdOn",
      label: "Time",
    },
    {
      key: "amount",
    },
    {
      key: "capturedBy",
      label: "Captured By",
    },
    {
      key: "approvedBy",
      label: "Approved By",
    }
  ]

    display = true;
    username = ""
    busy = false;
    processing = false;

    onSubmit() {
        this.processing = false
        this.busy = true
    };

    onCancel() {
        this.busy = false
    };

    onOK() {
        this.processing = true
    }


  mounted() {
    _axios
      .get(`${config.gateway}credits/deposit/Approved`)
      .then((response) => {
        console.log(response.data);
        this.items = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
  }
}